module.exports = __webpack_public_path__ + "forgot-password.97ad5e44a11f045ef182.svg";


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/assets/images/forgot-password.svg
// module id = ../../../../../src/assets/images/forgot-password.svg
// module chunks = main